module.exports = __webpack_public_path__ + "69abde3e308559046be1d91f4f3f9488.png";